import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeadingSection from '../../../../common/pageheading/PageHeadingSection';
import apiServices from '../../../../../services/apiService';
import CustomSelect from '../../../../common/formfields/CustomSelect';
import { primaryColor, secondaryColor } from '../../../../../utils/comon';

const VehicleTypeForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        name: "",
        isActiveId: "1"
    });

    const isEdit = !!location.state?.recordData;
    const recordData = location.state?.recordData;

    useEffect(() => {
        if (isEdit && recordData) {
            setFormData({
                name: recordData.VehicleTypename || "",
                isActiveId: recordData.isActive === "Active" ? "1" : "0"
            });
        }
    }, [isEdit, recordData]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (key, option) => {
        setFormData(prev => ({ ...prev, [key]: option ? option.value : null }));
    };

    const validateForm = () => {
        if (!formData.name.trim()) return toast.warning("Vehicle Type is required"), false;
        if (!formData.isActiveId) return toast.warning("Status is required"), false;
        return true;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setIsLoading(true);

        const payload = {
            name: formData.name,
            isActiveId: parseInt(formData.isActiveId)
        };

        try {
            let res;
            if (!isEdit) {
                res = await apiServices({
                    method: "POST",
                    url: `/VehicleTypeMaster/postVehicleType`,
                    data: payload
                });
            } else {
                res = await apiServices({
                    method: "PUT",
                    url: `/VehicleTypeMaster/putVehicleType/${recordData.VehicleTypeid}`,
                    data: payload
                });
            }

            if (res.isSuccess || res.success || res.IsSuccess) {
                toast.success(`Vehicle type ${isEdit ? "updated" : "added"} successfully`);
                navigate('/zentcomm/parking-management/vehicle-Type');
            } else {
                toast.error(res.message || `Failed to ${isEdit ? 'update' : 'create'} vehicle type`);
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast.error("An error occurred during submission.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4 scrollbar-hide">
            <PageHeadingSection 
                Navbar={true}
                mainHeading={`${isEdit ? 'Update' : 'Add'} Vehicle Type`}
                subHeading={`Please fill out the form below to ${isEdit ? 'update the existing' : 'create a new'} vehicle type.`}
            />
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div>
                    <label className="block text-xs font-bold text-gray-700 mb-1" htmlFor="name">
                        Vehicle Type <span className="text-red-500">*</span>
                    </label>
                    <input 
                        className="w-full px-3 py-2 border rounded-md text-sm outline-none focus:border-indigo-500 transition-colors" 
                        type="text" 
                        id="name" 
                        value={formData.name} 
                        onChange={handleInputChange} 
                        placeholder="e.g., 4 Wheeler"
                    />
                </div>

                <CustomSelect 
                    label={<>Status <span className="text-red-500">*</span></>}
                    options={[{label: 'Active', value: '1'}, {label: 'Inactive', value: '0'}]}
                    value={formData.isActiveId ? {label: formData.isActiveId === '1' ? 'Active' : 'Inactive', value: formData.isActiveId} : null}
                    onChange={(opt) => handleSelectChange('isActiveId', opt)}
                />
            </div>

            <div className="flex justify-between mt-auto border-t pt-4">
                <button
                    onClick={() => navigate("/zentcomm/parking-management/vehicle-Type")}
                    className="px-3 py-2 border rounded-md text-xs flex items-center gap-2 text-gray-600 hover:bg-gray-50 transition-colors"
                >
                    <FontAwesomeIcon icon={faAngleLeft} />
                    Cancel
                </button>

                <button
                    onClick={handleSubmit}
                    disabled={isLoading}
                    className="px-4 py-2 rounded-md text-xs font-bold flex items-center gap-2 shadow-sm hover:shadow-md active:scale-95 transition-all duration-200"
                    style={{ backgroundColor: secondaryColor(), color: primaryColor() }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = primaryColor();
                        e.currentTarget.style.color = '#FFFFFF';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = secondaryColor();
                        e.currentTarget.style.color = primaryColor();
                    }}
                >
                    {isLoading ? <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> : (isEdit ? 'Update' : 'Submit')}
                    <FontAwesomeIcon icon={faAngleRight} />
                </button>
            </div>
        </div>
    );
};

export default VehicleTypeForm;
